export default {"src":"/_next/static/media/17.5c307e48.svg","height":44,"width":44};